/* Meet add-on checkout guard (Ares Digital).
   Intercepts every Check out control and, based on live cart state:
   1. Requires a "Lifter name" (saved as a cart attribute → shows on the
      order) — parents/partners often order for someone else.
   2. If the cart holds a Highlight Reel Add-On but no video-containing
      package, warns that the add-on requires a video package.
   3. If the cart holds a Video / Photo & Video Package and no add-on,
      offers the matching meet's Highlight Reel one last time.
   4. Whenever a Highlight Reel is in the cart (or was just added), asks
      for the lifter's song choice (cart attribute "Song choice" → shows on
      the order and on the editor dashboard). Blank = team's choice.
   Works from cart page, drawer, and cart notification — no Liquid state. */
(function () {
  var ELIGIBLE = /^(Video Package|Photo & Video Package) \((.+)\)$/;
  var busy = false;

  function findCheckoutTrigger(el) {
    while (el && el !== document) {
      if (el.tagName === 'BUTTON' && el.name === 'checkout') return el;
      if (el.tagName === 'A' && el.href && el.href.indexOf('/checkout') !== -1) return el;
      el = el.parentElement;
    }
    return null;
  }

  function goCheckout() {
    window.location.href = '/checkout';
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function modal(innerHtml) {
    var old = document.getElementById('meet-addon-guard-modal');
    if (old) old.remove();
    var overlay = document.createElement('div');
    overlay.id = 'meet-addon-guard-modal';
    overlay.setAttribute('style',
      'position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.72);' +
      'display:flex;align-items:center;justify-content:center;padding:2rem;');
    overlay.innerHTML =
      '<div style="background:#111;color:#fff;max-width:34rem;width:100%;border:1px solid rgba(255,255,255,.25);border-radius:.6rem;padding:2.4rem;text-align:center;font-family:inherit;">' +
      innerHtml + '</div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.remove();
    });
    return overlay;
  }

  /* Step 1 — lifter name */
  function ensureLifterName(cart, next) {
    var existing = (cart.attributes && cart.attributes['Lifter name'] || '').trim();
    if (existing) { next(); return; }
    var overlay = modal(
      '<h2 style="margin:0 0 .6rem;font-size:2rem;color:#fff;">Who is the lifter?</h2>' +
      '<p style="margin:0 0 1.6rem;font-size:1.4rem;opacity:.85;">Ordering for someone else? Enter the name of the lifter on the platform so we deliver the right footage.</p>' +
      '<input id="meet-lifter-name" type="text" placeholder="Lifter’s full name" style="width:100%;padding:1rem;margin-bottom:.6rem;border-radius:.4rem;border:1px solid rgba(255,255,255,.4);background:#000;color:#fff;font-size:1.5rem;">' +
      '<p id="meet-lifter-err" style="display:none;color:#ff5c5c;font-size:1.2rem;margin:0 0 .6rem;">Please enter the lifter’s name.</p>' +
      '<button type="button" id="meet-lifter-continue" class="button" style="width:100%;cursor:pointer;">Continue</button>');
    var input = document.getElementById('meet-lifter-name');
    input.focus();
    function submit() {
      var val = input.value.trim();
      if (!val) {
        document.getElementById('meet-lifter-err').style.display = 'block';
        input.focus();
        return;
      }
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Lifter name': val } }),
      }).then(function () { overlay.remove(); next(); },
              function () { overlay.remove(); next(); });
    }
    document.getElementById('meet-lifter-continue').addEventListener('click', submit);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') submit();
    });
  }

  /* Step 1b — song for the highlight reel */
  var TEAM_PICK = "Team's choice (left blank at checkout)";
  function ensureSong(cart, next) {
    var existing = (cart && cart.attributes && cart.attributes['Song choice'] || '').trim();
    if (existing) { next(); return; }
    var overlay = modal(
      '<h2 style="margin:0 0 .6rem;font-size:2rem;color:#fff;">Pick a song for your highlight reel</h2>' +
      '<p style="margin:0 0 1.6rem;font-size:1.4rem;opacity:.85;">Tell us the song (and artist) you want behind your lifts. Leave it blank and our team will choose one for you using our best judgement.</p>' +
      '<input id="meet-song-choice" type="text" placeholder="Song title – Artist" style="width:100%;padding:1rem;margin-bottom:1rem;border-radius:.4rem;border:1px solid rgba(255,255,255,.4);background:#000;color:#fff;font-size:1.5rem;">' +
      '<button type="button" id="meet-song-continue" class="button" style="width:100%;margin-bottom:1rem;cursor:pointer;">Continue to checkout</button>' +
      '<button type="button" id="meet-song-skip" style="width:100%;background:none;border:none;color:#fff;opacity:.7;text-decoration:underline;font-size:1.3rem;cursor:pointer;">Let the team pick</button>');
    var input = document.getElementById('meet-song-choice');
    input.focus();
    function save(val) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Song choice': val } }),
      }).then(function () { overlay.remove(); next(); },
              function () { overlay.remove(); next(); });
    }
    document.getElementById('meet-song-continue').addEventListener('click', function () {
      save(input.value.trim() || TEAM_PICK);
    });
    document.getElementById('meet-song-skip').addEventListener('click', function () { save(TEAM_PICK); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') save(input.value.trim() || TEAM_PICK);
    });
  }

  /* Step 2 — orphan add-on warning */
  function warnOrphanAddon(addonItem) {
    var overlay = modal(
      '<h2 style="margin:0 0 .6rem;font-size:2rem;color:#fff;">Heads up — video package required</h2>' +
      '<p style="margin:0 0 1.6rem;font-size:1.4rem;opacity:.85;">The Highlight Reel Add-On requires a package that includes video (Video Package or Photo &amp; Video Package). Add one to qualify, or remove the add-on.</p>' +
      '<button type="button" id="meet-orphan-back" class="button" style="width:100%;margin-bottom:1rem;cursor:pointer;">Go back &amp; add a video package</button>' +
      '<button type="button" id="meet-orphan-remove" style="width:100%;background:none;border:none;color:#fff;opacity:.7;text-decoration:underline;font-size:1.3rem;cursor:pointer;">Remove Highlight Reel and check out</button>');
    document.getElementById('meet-orphan-back').addEventListener('click', function () {
      overlay.remove();
    });
    document.getElementById('meet-orphan-remove').addEventListener('click', function () {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: addonItem.key, quantity: 0 }),
      }).then(goCheckout, goCheckout);
    });
  }

  /* Step 3 — last-chance upsell */
  function offerAddon(product, variant) {
    var img = product.featured_image
      ? '<img src="' + product.featured_image + '&width=180" alt="" style="width:9rem;height:9rem;object-fit:cover;border-radius:.4rem;margin:0 auto 1.2rem;display:block;">'
      : '';
    var overlay = modal(
      img +
      '<h2 style="margin:0 0 .6rem;font-size:2rem;color:#fff;">Add a Highlight Reel?</h2>' +
      '<p style="margin:0 0 1.6rem;font-size:1.4rem;opacity:.85;">' +
      product.title + ' — ' + money(variant.price) +
      '<br>Limited to 10 per meet.</p>' +
      '<button type="button" id="meet-addon-guard-add" class="button" style="width:100%;margin-bottom:1rem;cursor:pointer;">Add + Check out</button>' +
      '<button type="button" id="meet-addon-guard-skip" style="width:100%;background:none;border:none;color:#fff;opacity:.7;text-decoration:underline;font-size:1.3rem;cursor:pointer;">No thanks, continue to checkout</button>');
    var addBtn = document.getElementById('meet-addon-guard-add');
    document.getElementById('meet-addon-guard-skip').addEventListener('click', goCheckout);
    addBtn.addEventListener('click', function () {
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 }),
      }).then(function () { ensureSong(null, goCheckout); }, goCheckout);
    });
  }

  function afterLifterName(cart) {
    var addonItem = null;
    var match = null;
    cart.items.forEach(function (i) {
      if (!addonItem && i.product_title.indexOf('Highlight Reel') === 0) addonItem = i;
      if (!match) match = i.product_title.match(ELIGIBLE);
    });

    if (addonItem && !match) {
      warnOrphanAddon(addonItem);
      return;
    }
    if (addonItem) {
      ensureSong(cart, goCheckout);
      return;
    }
    if (!match) {
      goCheckout();
      return;
    }
    var code = match[2].toLowerCase();
    fetch('/products/highlight-reel-add-on-' + code + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('no addon product');
        return r.json();
      })
      .then(function (p) {
        var v = p.variants && p.variants[0];
        if (v && v.available) {
          offerAddon(p, v);
        } else {
          goCheckout();
        }
      })
      .catch(goCheckout);
  }

  document.addEventListener('click', function (e) {
    var trigger = findCheckoutTrigger(e.target);
    if (!trigger || busy) return;
    e.preventDefault();
    e.stopPropagation();
    busy = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        busy = false;
        if (!cart.items.length) { goCheckout(); return; }
        ensureLifterName(cart, function () { afterLifterName(cart); });
      })
      .catch(function () { busy = false; goCheckout(); });
  }, true);
})();
